import { render, staticRenderFns } from "./ScreenUsage.vue?vue&type=template&id=40abdc76&"
import script from "./ScreenUsage.vue?vue&type=script&lang=js&"
export * from "./ScreenUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports